export default __webpack_public_path__ + "static/Intercom-bb2b19044f5db5fa5d486f385881cca5.png";